export class MathFormula {
    static RoundValueASTM(val, roundFormat) {
        return val;
    }

    // Returns whether given value is present between the given range.
    static between = (value, min, max) => {
        return value >= min && value <= max;
    }

    static roundAccurately = (number, decimalPlaces) =>{
        
        //decimalPlaces=decimalPlaces.toString()
        if (number)
            return Number(Math.round(number + "e" + decimalPlaces) + "e-" + decimalPlaces);
        else
            return 0;
    }
    //number!==""
    static TryParseFloat = (str, result) =>{
        if (str!=null && str.toString().length > 0 && !isNaN(str)) {
            result.value = parseFloat(str);
            return true;
        }
        return false;
    }
}